import {Box, Button, makeStyles} from '@material-ui/core';

const useStyles = makeStyles(() => ({
  btn: {
    fontFamily: 'roboto-regular',
    fontSize: 16,
    padding: '6px 27px',
    background: '#017AEF',
    margin:"10px",
    color: '#fff',
    textTransform: 'none',
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
    '&:disabled': {
      background: '#c0c5c8',
      color: '#474646',
    },
    '@media (max-width: 600px)': {
      padding: '3px 12px',
      fontSize: 11,
    },
  },
  backBtn: {
    fontFamily: 'roboto-regular',
    fontSize: 16,
    padding: '6px 27px',
    background: '#F0F0F0',
    color: '#697683',
    textTransform: 'none',
    boxShadow: 'unset',
    '&:hover': {
      boxShadow: 'unset',
      background: '#e2e2e2',
      color: '#697683',
    },
    '@media (max-width: 600px)': {
      padding: '3px 12px',
      fontSize: 11,
    },
  },
  icon: {
    width: 28,
    height: 28,
    marginLeft: 10,
    '@media (max-width: 600px)': {
      width: 18,
      height: 18,
    },
  },
  pressDiv: {
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 600px)': {
      display: 'none'
    },
  },
  press: {
    fontFamily: 'roboto-regular',
    fontSize: 10,
    color: '#212D40'
  },
  enter: {
    fontFamily: 'roboto-bold',
    fontSize: 10,
    color: '#212D40'
  }
}));

const OnboardingBtn = (props: any) => {

  const classes = useStyles();
  const { title, goNext, goBack, style, isRight, hiddenBack } = props;

  return (
    isRight ? (
      <Box mt={4} display='flex' flexDirection='row' alignItems='center' justifyContent={hiddenBack ? 'flex-end' : 'space-between'} sx={style ? {...style} : {}}>
        {!hiddenBack && (
          <Button className={classes.backBtn} variant="contained" size='large' onClick={goBack}>
            Back
          </Button>
        )}
        <div style={{ display: 'flex' }}>
          <Button className={classes.btn} color='primary' size='large' onClick={goNext}>
            {title}
            <img src={'/assets/icons/arrow-right-circle.svg'} alt="{}" className={classes.icon}/>
          </Button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <div className={classes.pressDiv}>
            <span className={classes.press}>press</span>&nbsp;
            <span className={classes.enter}>Enter</span>
          </div>
        </div>
      </Box>
    ) : (
      <Box
        mt={4} display='flex' flexDirection='row' alignItems='center' justifyContent='center'
        style={{ position: 'relative' }} sx={style ? {...style} : {}}
      >
        {!hiddenBack && (
          <Button className={classes.backBtn} style={{ position: 'absolute', left: 0, marginLeft: 0 }} variant="contained" size='large' onClick={goBack}>
            Back
          </Button>
        )}
        <Button className={classes.btn} color='primary' size='large' onClick={goNext}>
          {title}
        </Button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <div className={classes.pressDiv}>
          <span className={classes.press}>press</span>&nbsp;
          <span className={classes.enter}>Enter</span>
        </div>
      </Box>
    )
  );
};

export default OnboardingBtn;
